import { useState, useMemo, useEffect } from 'react';
import { extractNumber } from '@/lib/utils';
import useCopilotValueStore from '@/stores/copilotValueStore';

interface LevelText {
  expectedReturn: string;
  maxDrawdown: string;
  investmentAmount: string;
}

export const useClientNeeds = () => {
  // 滑块值状态
  const [expectedReturn, setExpectedReturn] = useState([3]); // 3%-20%，默认25%位置
  const [maxDrawdown, setMaxDrawdown] = useState([1]); // 1%-30%，默认15%位置
  const [investmentAmount, setInvestmentAmount] = useState([1]); // 1万-1000万，默认50%位置
  const [description, setDescription] = useState(
    '您的投资需求符合当前市场环境，建议采用均衡配置策略，注意分散投资风险'
  );

  const { copilotValue4 } = useCopilotValueStore();

  useEffect(() => {
    if (copilotValue4 && Object.keys(copilotValue4).length > 0) {
      setExpectedReturn([Number(extractNumber(copilotValue4.returnRes || '3')) || 0]);
      setMaxDrawdown([Number(extractNumber(copilotValue4.pullback || '1')) || 0]);
      setInvestmentAmount([Number(extractNumber(copilotValue4.amount || '1')) || 0]);
    }
  }, [copilotValue4]);

  const levelText = useMemo(() => {
    const obj: LevelText = {
      expectedReturn: '保守收益目标',
      maxDrawdown: '低风险承受能力',
      investmentAmount: '小规模投资'
    };

    if (expectedReturn[0] > 5) {
      obj.expectedReturn = '中等收益目标';
    }
    if (expectedReturn[0] > 10) {
      obj.expectedReturn = '积极收益目标';
      setDescription('您的投资需求符合当前市场环境，建议采用均衡配置策略，注意分散投资风险。');
    }
    if (expectedReturn[0] > 15) {
      obj.expectedReturn = '激进收益目标';
      setDescription(
        '您的投资需求较为激进，建议适当降低收益预期或提高风险承受能力，以实现更稳健的投资。'
      );
    }
    if (maxDrawdown[0] > 3) {
      obj.maxDrawdown = '中等风险承受能力';
    }
    if (maxDrawdown[0] > 8) {
      obj.maxDrawdown = '较高风险承受能力';
      setDescription('您的投资需求符合当前市场环境，建议采用均衡配置策略，注意分散投资风险。');
    }
    if (maxDrawdown[0] > 16) {
      obj.maxDrawdown = '高风险承受能力';
      setDescription(
        '您的投资需求较为激进，建议适当降低收益预期或提高风险承受能力，以实现更稳健的投资。'
      );
    }
    if (investmentAmount[0] > 50) {
      obj.investmentAmount = '中等规模投资';
    }
    if (investmentAmount[0] > 200) {
      obj.investmentAmount = '大规模投资';
      setDescription('您的投资需求符合当前市场环境，建议采用均衡配置策略，注意分散投资风险。');
    }
    if (investmentAmount[0] > 500) {
      obj.investmentAmount = '超大规模投资';
      setDescription(
        '您的投资需求较为激进，建议适当降低收益预期或提高风险承受能力，以实现更稳健的投资。'
      );
    }

    return obj;
  }, [expectedReturn, maxDrawdown, investmentAmount]);

  // 生成方案参数
  const generatePlanParams = () => {
    return JSON.stringify({
      return_res: `${expectedReturn[0]}%`,
      pullback: `${maxDrawdown[0]}%`,
      amout: `${investmentAmount[0]}`,
      drop_product: ''
    });
  };

  return {
    expectedReturn,
    maxDrawdown,
    investmentAmount,
    description,
    levelText,
    setExpectedReturn,
    setMaxDrawdown,
    setInvestmentAmount,
    generatePlanParams
  };
};
